(() => {
  const selector = '[data-cj-request]';

  function init(root) {
    if (!root || root.dataset.requestInitialized === 'true') return;

    const form = root.querySelector('form');
    const steps = Array.from(root.querySelectorAll('[data-step]'));
    const nextButton = root.querySelector('[data-next]');
    const backButton = root.querySelector('[data-back]');
    const submitButton = root.querySelector('[data-submit]');

    if (!form || !steps.length || !nextButton || !backButton || !submitButton) return;

    const stepLabel = root.querySelector('[data-step-label]');
    const stepName = root.querySelector('[data-step-name]');
    const progressBar = root.querySelector('[data-progress-bar]');
    const feedback = root.querySelector('[data-form-feedback]');
    const desk = root.querySelector('.cj-request__desk');
    const stepNames = ['Project', 'Details', 'Budget', 'Contact'];
    let currentStep = 0;

    root.dataset.requestInitialized = 'true';
    root.classList.add('is-enhanced');

    function clearErrors(scope = root) {
      scope.querySelectorAll('.is-invalid').forEach((element) => element.classList.remove('is-invalid'));
      if (feedback) {
        feedback.hidden = true;
        feedback.textContent = '';
      }
    }

    function fieldContainer(field) {
      if (field.type === 'radio') return field.closest('.cj-request__choices');
      if (field.type === 'checkbox') return field.closest('.cj-request__check');
      return field.closest('.cj-request__field');
    }

    function firstInvalid(step) {
      return Array.from(step.querySelectorAll('input, textarea, select')).find((field) => !field.checkValidity());
    }

    function validate(step, announce = true) {
      clearErrors(step);
      const invalid = firstInvalid(step);
      if (!invalid) return true;

      fieldContainer(invalid)?.classList.add('is-invalid');
      if (announce && feedback) {
        feedback.textContent = 'Finish the highlighted question before continuing.';
        feedback.hidden = false;
      }

      invalid.focus({ preventScroll: true });
      fieldContainer(invalid)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    function showStep(index, shouldScroll = true) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));
      clearErrors();

      steps.forEach((step, stepIndex) => {
        const active = stepIndex === currentStep;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      backButton.hidden = currentStep === 0;
      nextButton.hidden = currentStep === steps.length - 1;
      submitButton.hidden = currentStep !== steps.length - 1;

      if (stepLabel) stepLabel.textContent = `Step ${currentStep + 1} of ${steps.length}`;
      if (stepName) stepName.textContent = stepNames[currentStep] || '';
      if (progressBar) progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;

      if (shouldScroll && desk) {
        const top = desk.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.45) {
          desk.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      const firstControl = steps[currentStep].querySelector('input:not([type="hidden"]), textarea, select');
      window.setTimeout(() => firstControl?.focus({ preventScroll: true }), 180);
    }

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-next]')) {
        event.preventDefault();
        if (validate(steps[currentStep])) showStep(currentStep + 1);
      }

      if (event.target.closest('[data-back]')) {
        event.preventDefault();
        showStep(currentStep - 1);
      }
    });

    form.addEventListener('input', (event) => {
      fieldContainer(event.target)?.classList.remove('is-invalid');
      if (feedback && !firstInvalid(steps[currentStep])) {
        feedback.hidden = true;
        feedback.textContent = '';
      }
    });

    form.addEventListener('change', (event) => {
      fieldContainer(event.target)?.classList.remove('is-invalid');
      if (event.target.type === 'radio') event.target.closest('.cj-request__choices')?.classList.remove('is-invalid');
    });

    form.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.tagName !== 'TEXTAREA' && currentStep < steps.length - 1) {
        event.preventDefault();
        if (validate(steps[currentStep])) showStep(currentStep + 1);
      }
    });

    form.addEventListener('submit', (event) => {
      const invalidStep = steps.findIndex((step) => firstInvalid(step));
      if (invalidStep !== -1) {
        event.preventDefault();
        showStep(invalidStep);
        validate(steps[invalidStep]);
        return;
      }

      submitButton.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitButton.innerHTML = 'Sending…';
    });

    showStep(0, false);
  }

  function initAll(scope = document) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
